import React from 'react'
import { Grid } from '@softwaredev_cegeka/stix-core'

import { authenticatedUserStore } from 'src/stores'
import LastLoggedInUsersTable from 'src/components/HomePageWidgets/LastLoggedInUsersTable'
import MostPopularGroupsChart from 'src/components/HomePageWidgets/MostPopularGroupsChart'

import './mainRoute.scss'

export default class HomePage extends React.Component {
    render() {
        return (
            <Grid.Container className={'main-page'}>
                <h1 className={'name-header'}>
                    Hello, {authenticatedUserStore.firstName}!
                </h1>
                <p className="stix-lead stix-text-center">
                    Welcome to the{' '}
                    {authenticatedUserStore.userOrganization || ''} user
                    management app!
                </p>
                <Grid.Row className="widgets-container">
                    <Grid.Col md={7}>
                        <LastLoggedInUsersTable {...this.props} />
                    </Grid.Col>
                    <Grid.Col md={5}>
                        <MostPopularGroupsChart
                            selectedOrganization={
                                this.props.selectedOrganization
                            }
                        />
                    </Grid.Col>
                </Grid.Row>
            </Grid.Container>
        )
    }
}
